import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const getWorkOrder = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}.json`
  ).then((response) => response.data)

export const createWorkOrder = (
  marinaSlug,
  { contactId, contactBoatId, requestDescription }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders`,
    method: "POST",
    data: {
      work_order: {
        contact_id: contactId,
        contact_boat_id: contactBoatId,
        request_description: requestDescription,
      },
    },
  }).then((response) => response.data)

export const scheduleWorkOrder = (marinaSlug, sequentialId, { scheduledAt }) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/schedule`,
    method: "PATCH",
    data: {
      work_order: { scheduled_at: scheduledAt },
    },
  }).then((response) => response.data)

export const closeWorkOrder = (marinaSlug, sequentialId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/close`,
    method: "POST",
  }).then((response) => response.data)

export const reopenWorkOrder = (marinaSlug, sequentialId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/reopen`,
    method: "POST",
  }).then((response) => response.data)

export const getBillableJobs = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/billable_jobs.json`
  ).then((response) => response.data)

export const getInvoicePreview = (marinaSlug, sequentialId, jobIds) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/invoice_preview`,
    method: "POST",
    data: { job_ids: jobIds },
  }).then((response) => response.data)

export const generateInvoice = (
  marinaSlug,
  sequentialId,
  { jobIds, dueDate, sendEmail }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/generate_invoice`,
    method: "POST",
    data: {
      invoice: { job_ids: jobIds, due_date: dueDate, send_email: sendEmail },
    },
  }).then((response) => response.data)

export const updateAutopay = (
  marinaSlug,
  sequentialId,
  { autopayEnabled, stripePaymentMethodId, applyToExisting }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/autopay`,
    method: "PATCH",
    data: {
      autopay_enabled: autopayEnabled,
      stripe_card_id: stripePaymentMethodId,
      apply_to_existing: applyToExisting,
    },
  }).then((response) => response.data)

export const getPaymentMethodOptions = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/payment_method_options.json`
  ).then((response) => response.data)
